// https://github.com/Grsmto/simplebar
// https://github.com/Grsmto/simplebar/tree/master/packages/simplebar-react

import React from 'react';
import SimpleBar from 'simplebar-react';
import 'simplebar/dist/simplebar.min.css';
import '../../../assets/sass/components/simplebar.scss';

const SimpleScrollbar = function (props) {

    const ref = React.useRef();
    const scrollableNodeRef = React.createRef();

    const style = {};

    if(props.maxHeight)
        style.maxHeight = props.maxHeight;
    if(props.minHeight)
        style.minHeight = props.minHeight;

    React.useEffect(() => {

        if(props.scrollbottom)
            if(scrollableNodeRef.current)
                scrollableNodeRef.current.scrollTop = ref.current.contentEl.scrollHeight;

        window.addEventListener('resize', function(e) {
            ref.current.recalculate();
        });

        scrollableNodeRef.current.addEventListener('scroll', function(e) {
            if(props.onScroll)
                props.onScroll(e);
        })
    })

    return (
        <SimpleBar
            ref={ref}
            scrollableNodeProps={{ ref: scrollableNodeRef }}
            style={style}
            autoHide={true}
            {...props}
        >
            {props.children}
        </SimpleBar>
    );
}

export default SimpleScrollbar;
